module.exports = __webpack_public_path__ + "static/img/prezzta.c01c507c.svg";